import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';

export interface IBlockScreen {
  id?: number;
  show?: boolean | null;
  createdBy?: string | null;
  createdDate?: string | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: string | null;
  truckImplement?: ITruckImplement | null;
}

export const defaultValue: Readonly<IBlockScreen> = {
  show: false,
};
